import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-violet-900 to-purple-800 text-white py-12 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <h3 className="text-2xl font-bold heading-font mb-4 text-yellow-300">Thomas Party & Decor</h3>
            <p className="text-gray-200 mb-3">
              Premium party rental equipment for all your special occasions.
            </p>
            <p className="text-gray-300 text-sm">
              📍 Aldan, PA 19018<br />
              📞 <a href="tel:484-957-0076" className="hover:text-yellow-300 transition-colors">484-957-0076</a><br />
              ✉️ <a href="mailto:thomaspartydecor@gmail.com" className="hover:text-yellow-300 transition-colors">thomaspartydecor@gmail.com</a>
            </p>
            <a
              href="https://www.instagram.com/thomaspartydecor"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram-link"
              className="inline-flex items-center gap-2 mt-4 text-gray-200 hover:text-yellow-300 transition-colors"
            >
              <Instagram className="w-5 h-5" />
              <span>@thomaspartydecor</span>
            </a>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold heading-font mb-4 text-yellow-300">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-200 hover:text-yellow-300 transition-colors">Products</Link>
              </li>
              <li>
                <Link to="/packages" className="text-gray-200 hover:text-yellow-300 transition-colors">Packages</Link>
              </li>
              <li>
                <Link to="/gallery" className="text-gray-200 hover:text-yellow-300 transition-colors">Gallery</Link>
              </li>
              <li>
                <Link to="/request-a-quote" className="text-gray-200 hover:text-yellow-300 transition-colors">Request a Quote</Link>
              </li>
              <li>
                <Link to="/rental-policies" className="text-gray-200 hover:text-yellow-300 transition-colors">Rental Policies</Link>
              </li>
              <li>
                <a href="tel:484-957-0076" className="text-gray-200 hover:text-yellow-300 transition-colors">Book Now</a>
              </li>
            </ul>
          </div>

          {/* Service Area */}
          <div>
            <h3 className="text-xl font-bold heading-font mb-4 text-yellow-300">Service Areas</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/party-rentals-philadelphia-pa" className="text-gray-200 hover:text-yellow-300 transition-colors">Party Rentals Philadelphia</Link>
              </li>
              <li>
                <Link to="/party-rentals-delaware-county-pa" className="text-gray-200 hover:text-yellow-300 transition-colors">Party Rentals Delaware County</Link>
              </li>
              <li>
                <Link to="/party-rentals-main-line-pa" className="text-gray-200 hover:text-yellow-300 transition-colors">Party Rentals Main Line</Link>
              </li>
              <li>
                <Link to="/tent-rentals-philadelphia-pa" className="text-gray-200 hover:text-yellow-300 transition-colors">Tent Rentals Philadelphia</Link>
              </li>
              <li>
                <Link to="/table-chair-rentals-philadelphia-pa" className="text-gray-200 hover:text-yellow-300 transition-colors">Table & Chair Rentals</Link>
              </li>
              <li>
                <Link to="/graduation-party-rentals-philadelphia-pa" className="text-gray-200 hover:text-yellow-300 transition-colors">Graduation Party Rentals</Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Safety & Disclaimer */}
        <div className="border-t border-white/20 pt-6 mb-6">
          <h4 className="text-lg font-bold heading-font mb-3 text-yellow-300">⚠️ Safety & Liability Notice</h4>
          <div className="text-gray-300 text-sm space-y-2">
            <p>
              <strong>Equipment Safety:</strong> All rental equipment is inspected before delivery. Customers are responsible for proper setup, use, and supervision of all rented items. Please ensure adequate space and safe conditions for all equipment.
            </p>
            <p>
              <strong>Tent Safety:</strong> Tents must be securely anchored. Do not use in severe weather conditions including high winds, lightning, or heavy storms. Customer is responsible for monitoring weather conditions and securing or taking down equipment if necessary.
            </p>
            <p>
              <strong>Supervision Required:</strong> Adult supervision is required at all times when children are present around rental equipment, especially chairs, tables, and decorative items.
            </p>
            <p>
              <strong>Liability:</strong> Thomas Party & Decor is not liable for injuries, damages, or losses resulting from improper use, setup, or supervision of rental equipment. Customers assume full responsibility for the safe use of all rented items.
            </p>
            <p>
              <strong>Damage & Loss:</strong> Customer is responsible for any damage to or loss of rental equipment during the rental period. Please inspect all items upon delivery and report any issues immediately.
            </p>
          </div>
        </div>

        {/* Copyright */}
        <div className="text-center text-gray-300 text-sm border-t border-white/20 pt-6">
          <p>© {new Date().getFullYear()} Thomas Party & Decor. All rights reserved.</p>
          <p className="mt-2">Serving Havertown, Delaware County, Montgomery County & Surrounding Areas</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;